import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import type HotelSettingsCompetitorsBenchmarkCompsetBuilderGenerateRoute from 'lumen/routes/hotel/settings/competitors/benchmark/compset/builder/generate';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCompetitorsBenchmarkCompsetBuilderGenerateController extends Controller {
  declare model: ModelFrom<HotelSettingsCompetitorsBenchmarkCompsetBuilderGenerateRoute>;

  @service declare router: Services['router'];

  get showUpdateHeaderTranslation(): boolean {
    if (!this.model.compset.last?.value) {
      return false;
    }

    return this.model.compset.last.value.competitors.length > 0;
  }

  @action onClose(): void {
    // Use legacyTransitionTo to avoid the parent model refreshing
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.router.legacyTransitionTo(
      'hotel.settings.competitors.benchmark.compset.index',
    );

    // Cancel the last task, otherwise the API request will continue in the background.
    // This is important to avoid the success callback being called, which would navigate back to the compset builder proposals route.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this.model.proposedCompsets.last?.cancel();
  }
}
